
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6e42dc47!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TaskDetailsMass.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TaskDetailsMass.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6e42dc47!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TaskDetailsMass.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/copyrighter/taskManagement/TaskDetailsMass.vue
// module id = 1057
// module chunks = 0